import { useEffect } from 'react';
import HeaderMetedBase from './HeaderMetedBase';

import { connect, useDispatch } from 'react-redux'
import { getCatalog } from '../../actions'
import Loading from './Loading';
import RegisterContainer from './RegisterContainer';


function CatalogController(props) {
    const dispatch = useDispatch();
    const { viewer } = props

    return <BrowseContainer  />
    /*
    useEffect(() => {
        dispatch(getCatalog());
    }, [dispatch]);

    if (viewer.catalog_initialized) {
        let content = [];
        
        return <BrowseContainer content={content} tabKey={props.tabKey} />

    } else {
        return <Loading />
    }
*/
}

const BrowseContainer = () => {

    return (
        <div id='et-browse-container'>

            <HeaderMetedBase activePage="catalog" />
            <RegisterContainer />

        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        viewer: state.viewer,
        user: state.user,
    };
}

export default connect(mapStateToProps)(CatalogController);